"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var ui_components_2 = require("@l2p/ui-components");
var ui_components_3 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var Fields = function (_a) {
    var welcomeFields = _a.welcomeFields, isSubmitting = _a.isSubmitting;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldsWrapper },
            welcomeFields.includes('nickname') ? (react_1.default.createElement(react_final_form_1.Field, { name: "nickname", render: function (_a) {
                    var input = _a.input, meta = _a.meta;
                    return (react_1.default.createElement("div", null,
                        react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: "light", placeholder: t('enterNickname'), helperButton: meta.error && meta.touched && { type: 'error' } })),
                        meta.error && meta.touched && (react_1.default.createElement(ui_components_2.ErrorText, null, meta.error))));
                } })) : null,
            welcomeFields.includes('email') ? (react_1.default.createElement(react_final_form_1.Field, { name: "email", render: function (_a) {
                    var input = _a.input, meta = _a.meta;
                    return (react_1.default.createElement("div", null,
                        react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: "light", placeholder: "user@gmail.com", helperButton: meta.error && meta.touched && { type: 'error' } })),
                        meta.error && meta.touched && (react_1.default.createElement(ui_components_2.ErrorText, null, meta.error))));
                } })) : null,
            welcomeFields.includes('password') ? (react_1.default.createElement(react_final_form_1.Field, { name: "password", render: function (_a) {
                    var input = _a.input, meta = _a.meta;
                    return (react_1.default.createElement("div", null,
                        react_1.default.createElement(ui_components_1.InputPassword, __assign({}, input, { mode: "light", placeholder: t('enterPassword'), hasError: meta.error && meta.touched })),
                        meta.error && meta.touched && (react_1.default.createElement(ui_components_2.ErrorText, null, meta.error))));
                } })) : null),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
            react_1.default.createElement(ui_components_3.FixedButton, { maxWidth: "initial", type: "submit", color: "gradient", text: "upper", loading: isSubmitting }, t('signup')))));
};
exports.default = Fields;
